// extracted by mini-css-extract-plugin
module.exports = {"menu":"TagsListsCheckableDropdownInput_menu__2xFU3","dropdown":"TagsListsCheckableDropdownInput_dropdown__1Yo0S"};